import { render, staticRenderFns } from "./ScreenConfigureCamera.vue?vue&type=template&id=bf0f5e3c&scoped=true&"
import script from "./ScreenConfigureCamera.vue?vue&type=script&lang=js&"
export * from "./ScreenConfigureCamera.vue?vue&type=script&lang=js&"
import style0 from "./ScreenConfigureCamera.vue?vue&type=style&index=0&id=bf0f5e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0f5e3c",
  null
  
)

export default component.exports